import React, {useEffect, useMemo, useState} from 'react';
import axios from "axios";
import {API_BASE_URL} from "../config";
import Modal from 'react-modal';
import '../assets/css/Users.css';
import {useNavigate} from "react-router-dom";
import Button from "../components/Elements/Button";
import {generateStrongPassword} from "../utils/passwordUtils";

const UsersList = () => {
    const [users, setUsers] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true) ;
    };
    const closeModal = () => setIsModalOpen(false);
    const [user, setUser] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('')
    const [department, setDepartment] = useState('')
    const [registerMessage, setRegisterMessage] = useState('');
    const roles = ['Administrateur', 'Editeur', 'Consultant'];
    const [departments, setDepartments] = useState([]);
    const [password, setPassword] = useState('');
    const [triggerUserRefresh, setTriggerUserRefresh] = useState(false);
    const [sortBy, setSortBy] = useState({column: 'name', ascending: true});

    const navigate = useNavigate();

    const handleSort = (column) => {
        setSortBy(prev => ({
            column,
            ascending: prev.column === column ? !prev.ascending : true,
        }));
    };

    const sortedUsers = useMemo(() => {
        const cmp = (a, b) => {
            const dir = sortBy.ascending ? 1 : -1;
            const get = (u) => {
                switch (sortBy.column) {
                    case 'name':
                        return `${u.firstname || ''} ${u.lastname || ''}`.trim().toLowerCase() || (u.username || '').toLowerCase();
                    case 'email':
                        return (u.email || '').toLowerCase();
                    case 'role':
                        return (u.role_name || String(u.role ?? '')).toLowerCase();
                    case 'department':
                        return (u.department_names || '').toLowerCase();
                    default:
                        return '';
                }
            };
            return get(a).localeCompare(get(b)) * dir;
        };
        return [...users].sort(cmp);
    }, [users, sortBy]);

    const SortIcon = ({column}) => {
        const isActive = sortBy.column === column;
        return (
            <span
                aria-hidden="true"
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 18,
                    height: 18,
                    marginLeft: 8,
                    borderRadius: 4,
                    fontSize: 10,
                    lineHeight: 1,
                    background: isActive ? 'rgba(0,0,0,0.08)' : 'transparent',
                    color: isActive ? '#111' : '#bbb',
                    transition: 'all 0.15s',
                }}
            >
                {isActive ? (sortBy.ascending ? '▲' : '▼') : '↕'}
            </span>
        );
    };

    const thStyle = {
        cursor: 'pointer',
        userSelect: 'none',
        padding: '12px 16px',
        textAlign: 'left',
        whiteSpace: 'nowrap',
    };
    const tdStyle = {padding: '12px 16px'};

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_all_departments`, {user, email, password, role})
            .then(response => {
                setDepartments(response.data);
            })
            .catch(error => {
                // Handle network errors
                console.error('Error:', error);
                setRegisterMessage('An error occurred. Please try again later.');
            });

        axios.post(`${API_BASE_URL}/get_users`)
            .then(res => {
                const {data} = res;
                if (Array.isArray(data) && data.length > 0) {
                    const usersArray = data.map(user => ({
                        ...user,
                        departmentNames: user.department_names ? user.department_names.split(',') : [], // Convert to array
                        departmentIds: user.department_id ? user.department_id.split(',').map(id => id.trim()) : [] // Convert to array and trim spaces
                    }));

                    console.log(usersArray);
                    setUsers(usersArray);
                } else {
                    console.warn('No users found or invalid response structure');
                }
            })
            .catch(error => {
                console.error('Error fetching user data:', error);
            });

    }, [email, password, role, user, triggerUserRefresh]);


    useEffect(() => {
        document.title = 'Utilisateurs'
    }, []);
    const handleRegister = (e) => {
        e.preventDefault();

        axios.post(`${API_BASE_URL}/register`, {user, email, password, role})
            .then(response => {
                if (response.data.status === 'ok') {
                    // Successful login
                    // Perform actions such as setting user session, redirecting, etc.
                    setRegisterMessage('Utilisateur enregistré avec succès');
                    closeModal();
                    setTriggerUserRefresh((prev) => !prev)

                } else {
                    // Wrong credentials
                    setRegisterMessage('Une erreur est survenue.');
                }
            })
            .catch(error => {
                // Handle network errors
                console.error('Error:', error);
                setRegisterMessage('An error occurred. Please try again later.');
            });

    }

    useEffect(() => {
        console.log('ok')
    }, [user]);

    return (<div>
        <h2>Utilisateurs</h2>

        <table className="ticket-table">
            <thead>
            <tr>
                <th onClick={() => handleSort('name')} style={thStyle}>
                    Utilisateur<SortIcon column="name"/>
                </th>
                <th onClick={() => handleSort('email')} style={thStyle}>
                    Email<SortIcon column="email"/>
                </th>
                <th onClick={() => handleSort('role')} style={thStyle}>
                    Rôle<SortIcon column="role"/>
                </th>
                <th onClick={() => handleSort('department')} style={thStyle}>
                    Département<SortIcon column="department"/>
                </th>
            </tr>
            </thead>
            <tbody>
            {sortedUsers.map(user => (
                // Cliquer sur un utilisateur renvoie sur sa page pour l'administrer
                <tr key={user.id} className={'tr-user'} onClick={() => navigate('/utilisateur/' + user.id)}>
                    <td style={tdStyle}>
                        {user.firstname + ' ' + user.lastname}
                    </td>

                    <td style={tdStyle}>
                        {user.email}
                    </td>

                    <td style={tdStyle}>
                        {user.role_name || user.role}
                    </td>

                    <td style={tdStyle}>
                        {
                            // Ajout d'un espace entre les noms des départements pour que ce soit plus joli
                            user.department_names !== null && user.department_names.split(',').join(', ')
                        }
                    </td>
                </tr>))}
            </tbody>
        </table>

        <div className={"h-separator"}/>

        <div className={"display-flex gap-20 mt-20"}>
            <Button iconBackground={'bg-third'} onClick={() => openModal()}
                    icon={'fa-plus'} label={'Ajouter un utilisateur'}
                    textClassNames={'bg-third '}
                    iconClasseNames={'color-white'} disableLink/>

            <Button iconBackground={'bg-orangered'} onClick={() => navigate('/utilisateurs-supprimes')}
                    icon={'fa-trash'} label={'Voir les utilisateurs supprimés'}
                    textClassNames={'bg-orangered '}
                    iconClasseNames={'color-white'} disableLink/>
        </div>


        {/* Modal for Register Component */}
        <Modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            contentLabel="Ajouter un utilisateur"
            className="modal"
            overlayClassName="overlay"
            shouldCloseOnOverlayClick={true} // This will close the modal when the overlay is clicked
        >
            <div className="register-container">
                <form className="register-form" onSubmit={handleRegister}>
                    <h2 className="title">Création d'un utilisateur</h2>
                    <div className="input-container mb-0">
                        <div className="input-icon">
                            <i className="fas fa-user  color-third"></i>
                        </div>
                        <input className="input" type="text" placeholder="Prénom et nom" required
                               autoFocus={true}
                               value={user} onChange={(e) => setUser(e.target.value)}/>
                    </div>
                    <div className="input-container mb-0">
                        <div className="input-icon">
                            <i className="fas fa-envelope  color-third"></i>
                        </div>
                        <input className="input" type="email" placeholder="Email" required
                               value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </div>
                    <div className="input-container mb-0 ">
                        <div className="input-icon">
                            <i className="fas fa-lock  color-third"></i>
                        </div>
                        <input
                            className="input"
                            type="text"
                            placeholder="Mot de passe"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <span className="btn-generate" onClick={()=>setPassword(generateStrongPassword)}><i
                            className="fa-solid fa-arrows-rotate"></i></span>

                    </div>
                    <div className="input-container mb-0 ">
                        <div className="input-icon">
                            <i className="fa-solid fa-industry color-third"></i>
                        </div>
                        {/* Dropdown for roles */}
                        <select
                            className="input"
                            value={department}
                            onChange={(e) => setDepartment(e.target.value)}
                            required
                        >
                            <option value="" disabled hidden>Choisir un département</option>
                            {departments.map((department) => (
                                <option key={department.id} value={department.id}>{department.name}</option>))}
                        </select>
                    </div>
                    <div className="input-container mb-0 ">
                        <div className="input-icon">
                            <i className="fa-solid fa-user-lock color-third"></i>
                        </div>
                        {/* Dropdown for roles */}
                        <select
                            className="input"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            required
                        >
                            <option value="" disabled hidden>Choisir un rôle</option>
                            {roles.map((roleOption) => (
                                <option key={roleOption} value={roleOption}>{roleOption}</option>))}
                        </select>
                    </div>
                    {/* Display login error message */}
                    {registerMessage && <p className="error-message">{registerMessage}</p>}
                    <div className={"display-flex justify-content-end gap-10 btn-container"}>

                        <button className="btn-submit-account cancel" style={{backgroundColor: "#ce3b2a"}}
                                onClick={closeModal}>Annuler
                        </button>
                        <button className="btn-submit-account" type="submit">Enregistrer un utilisateur</button>


                    </div>
                </form>
            </div>
        </Modal>
    </div>)
}

export default UsersList;